import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VerDocumentosModalComponent } from '../../modales/ver-documentos-modal/ver-documentos-modal.component';

@Component({
  selector: 'app-documentos-drag-drop',
  templateUrl: './documentos-drag-drop.component.html',
  styleUrls: ['./documentos-drag-drop.component.css']
})
export class DocumentosDragDropComponent implements OnInit {
	@Input() showDragAndDrop: Boolean
	@Input() extension
	@Input() fileName
	@Output() emitLoadFile = new EventEmitter<any>();
	@Output() emitCleanDocument = new EventEmitter<any>();
	files: File[];
	maxSize: any
	Nombre;

  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
	  if(this.fileName.value === undefined){
		  this.Nombre = this.fileName
	  }else this.Nombre = this.fileName.value
  }

  handleCloseClick(){
	if(this.files !== undefined) this.files.pop();
	this.showDragAndDrop = true;
	this.emitCleanDocument.emit();

}

showModal(){
	let dialogRef = this.dialog.open(VerDocumentosModalComponent, {
		height: '70vh',
  		width: '900px',
		data: {
			documento: 'contrato',
			preview: true
		}
	});
	dialogRef.afterClosed().subscribe(res=>{
		console.log('RESPUESTA: ',res)
		dialogRef.close();
	})
}

loadFile(){
	this.emitLoadFile.emit(this.files)
}

ChangeShowDragAndDrop(value){
	this.showDragAndDrop = value;
}

ChangeFileName(value){
	this.Nombre = value
}


}
